import { type Shop, useAuthStore } from "@/stores/auth";

/** The Ads account type of a Shop in the signed-in user's list, or null while unknown. */
export function useShopAccountType(shopId: string | null | undefined): Shop["accountType"] {
  return useAuthStore(
    (state) => state.shops.find((shop) => shop.shopId === shopId)?.accountType ?? null,
  );
}

/**
 * Whether the Shop is a vendor (1P). Its catalog is keyed by ASIN and has no
 * SKU (#673), so product identities read as ASINs and Smart Creation products
 * carry the ASIN as their listing key (#674).
 */
export function useIsVendorShop(shopId: string | null | undefined): boolean {
  return useShopAccountType(shopId) === "vendor";
}
